import { ENDPOINT } from '~/constants';

import { LOADING_STATE } from '../constants/loadingState';
import CompanyIdentifier from '../models/CompanyIdentifier';
import {
  replaceCompanyIdentifiers,
  setCompanyIdentifiersLoading,
} from '../redux/companyIdentifiersSlice';
import store from '../redux/store';
import { promiseHandler } from '../utils/promiseHandler';

import { vestigasApi } from './kyClient';
import ToastService from './toast.service';

class CompanyIdentifierService {
  async getAllCompanyIdentifiers() {
    try {
      const response = await vestigasApi
        .get(ENDPOINT.COMPANY.IDENTIFIER.GET_ALL())
        .json();

      if (response.status !== 200) {
        return [];
      }

      return response.map((item) => {
        const companyIdentifier = new CompanyIdentifier();
        companyIdentifier.init(item);

        return companyIdentifier;
      });
    } catch (error) {
      ToastService.httpError(
        ['Kundennummern konnten nicht geladen werden.'],
        error.response,
      );
      return Promise.reject(error);
    }
  }

  async createNewCompanyIdentifier(body) {
    return vestigasApi.post(ENDPOINT.COMPANY.IDENTIFIER.CREATE(), {
      json: body,
    });
  }

  async deleteCompanyIdentifier(companyIdentifierId) {
    return vestigasApi.delete(
      ENDPOINT.COMPANY.IDENTIFIER.DELETE(companyIdentifierId),
    );
  }

  async loadCompanyIdentifiers() {
    // to not load companyIdentifiers again when they are already loading or have already been loaded
    if (
      store.getState().companyIdentifiers?.companyIdentifiersLoading !==
      LOADING_STATE.NOT_LOADED
    ) {
      return;
    }

    this.refreshCompanyIdentifiers();
  }

  async refreshCompanyIdentifiers() {
    store.dispatch(setCompanyIdentifiersLoading(LOADING_STATE.LOADING));

    const [companyIdentifiers, error] = await promiseHandler(
      this.getAllCompanyIdentifiers(),
    );

    if (error) {
      store.dispatch(setCompanyIdentifiersLoading(LOADING_STATE.FAILED));
      return;
    }

    store.dispatch(replaceCompanyIdentifiers(companyIdentifiers));
  }
}

export default new CompanyIdentifierService();
